import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ElementTur } from '../sablon-editoru/sablon.interface';

interface IPaletElement {
  tur: ElementTur;
  simge: string;
  isim: string;
}

interface IPaletKategori {
  baslik: string;
  simge: string;
  acik: boolean;
  elemanlar: IPaletElement[];
}

const KATEGORILER: IPaletKategori[] = [
  {
    baslik: 'Metin', simge: 'T', acik: true,
    elemanlar: [
      { tur: 'sabit-metin', simge: 'T', isim: 'Sabit' },
      { tur: 'parametre-metin', simge: '📝', isim: 'Param' },
      { tur: 'parametre-render', simge: '🔄', isim: 'Render' },
      { tur: 'markdown', simge: '📄', isim: 'Markdown' },
    ],
  },
  {
    baslik: 'Şekil & Medya', simge: '◻', acik: false,
    elemanlar: [
      { tur: 'sekil', simge: '◻', isim: 'Şekil' },
      { tur: 'resim', simge: '🖼', isim: 'Resim' },
      { tur: 'avatar', simge: '👤', isim: 'Avatar' },
      { tur: 'badge', simge: '🏷', isim: 'Badge' },
      { tur: 'qr-kod', simge: '📱', isim: 'QR Kod' },
      { tur: 'iframe', simge: '🌐', isim: 'iFrame' },
      { tur: 'lottie', simge: '✨', isim: 'Lottie' },
    ],
  },
  {
    baslik: 'Veri & Grafik', simge: '📊', acik: false,
    elemanlar: [
      { tur: 'sayac', simge: '🔢', isim: 'Sayaç' },
      { tur: 'gauge', simge: '⏱', isim: 'Gauge' },
      { tur: 'sparkline', simge: '📈', isim: 'Sparkline' },
      { tur: 'bar-grafik', simge: '📊', isim: 'Bar' },
      { tur: 'pasta-grafik', simge: '🥧', isim: 'Pasta' },
      { tur: 'alan-grafik', simge: '📉', isim: 'Alan' },
      { tur: 'radar-grafik', simge: '🎯', isim: 'Radar' },
      { tur: 'isi-haritasi', simge: '🌡', isim: 'Isı Haritası' },
      { tur: 'ilerleme-cubugu', simge: '▬', isim: 'İlerleme' },
      { tur: 'ilerleme-halka', simge: '⭕', isim: 'Halka' },
      { tur: 'seviye-cubugu', simge: '📶', isim: 'Seviye' },
    ],
  },
  {
    baslik: 'Zaman', simge: '🕐', acik: false,
    elemanlar: [
      { tur: 'dijital-saat', simge: '🕐', isim: 'Dijital' },
      { tur: 'analog-saat', simge: '⏰', isim: 'Analog' },
      { tur: 'countdown', simge: '⏳', isim: 'Geri Sayım' },
      { tur: 'kronometr', simge: '⏱', isim: 'Kronometre' },
      { tur: 'zaman-cizelgesi', simge: '📅', isim: 'Çizelge' },
    ],
  },
  {
    baslik: 'Durum', simge: '💡', acik: false,
    elemanlar: [
      { tur: 'durum-dot', simge: '🔴', isim: 'Durum Dot' },
      { tur: 'durum-kart', simge: '📋', isim: 'Durum Kart' },
      { tur: 'led-gosterge', simge: '💡', isim: 'LED' },
      { tur: 'trafik-isigi', simge: '🚦', isim: 'Trafik' },
      { tur: 'sinyal-cubugu', simge: '📶', isim: 'Sinyal' },
    ],
  },
  {
    baslik: 'Liste & Tablo', simge: '📋', acik: false,
    elemanlar: [
      { tur: 'liste-tekrar', simge: '📃', isim: 'Liste' },
      { tur: 'siralama-listesi', simge: '🏆', isim: 'Sıralama' },
      { tur: 'mini-tablo', simge: '📊', isim: 'Tablo' },
      { tur: 'kanban-sutun', simge: '📌', isim: 'Kanban' },
      { tur: 'ticker', simge: '📰', isim: 'Ticker' },
    ],
  },
  {
    baslik: 'Kontrol', simge: '⏯', acik: false,
    elemanlar: [
      { tur: 'buton', simge: '▶', isim: 'Buton' },
      { tur: 'toggle', simge: '🔘', isim: 'Toggle' },
      { tur: 'slider', simge: '🎚', isim: 'Slider' },
      { tur: 'tab-grup', simge: '📑', isim: 'Tab Grup' },
    ],
  },
];

@Component({
  selector: 'te-palet',
  standalone: true,
  imports: [CommonModule, NzTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="palet-kok" [class.dar]="darMod()">
      @for (kat of kategoriler; track kat.baslik) {
        <div class="kategori">
          <div class="kategori-baslik" (click)="kat.acik = !kat.acik"
            [nz-tooltip]="darMod() ? kat.baslik : ''" nzTooltipPlacement="right">
            <span class="kat-simge">{{ kat.simge }}</span>
            @if (!darMod()) {
              <span class="kat-isim">{{ kat.baslik }}</span>
            }
            <span class="kat-ok" [class.acik]="kat.acik">›</span>
          </div>
          @if (kat.acik) {
            <div class="eleman-grid" [class.dar-grid]="darMod()">
              @for (el of kat.elemanlar; track el.tur) {
                <div
                  class="eleman-tile"
                  [nz-tooltip]="darMod() ? el.isim : ''" nzTooltipPlacement="right"
                  (click)="elementEklendi.emit(el.tur)">
                  <span class="el-simge">{{ el.simge }}</span>
                  @if (!darMod()) {
                    <span class="el-isim">{{ el.isim }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  `,
  styles: `
    :host { display: block; height: 100%; }
    .palet-kok {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 4px;
      &::-webkit-scrollbar { width: 4px; }
      &::-webkit-scrollbar-thumb { background: var(--te-scrollbar, rgba(0,0,0,.12)); border-radius: 2px; }
    }

    .kategori {
      &:not(:last-child) { border-bottom: 1px solid var(--te-border, rgba(0,0,0,.08)); }
    }

    .kategori-baslik {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 6px;
      cursor: pointer;
      user-select: none;
      border-radius: 4px;
      transition: background .15s;
      &:hover { background: var(--te-hover, rgba(0,0,0,.04)); }
    }
    .kat-simge { font-size: 14px; flex-shrink: 0; width: 20px; text-align: center; }
    .kat-isim { font-size: 11px; font-weight: 500; color: var(--te-text-secondary, rgba(0,0,0,.6)); flex: 1; }
    .kat-ok {
      font-size: 12px; color: var(--te-text-muted, rgba(0,0,0,.3));
      transition: transform .2s;
      &.acik { transform: rotate(90deg); }
    }

    .eleman-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 3px;
      padding: 0 2px 6px;
    }
    .dar-grid { grid-template-columns: 1fr 1fr; }

    .eleman-tile {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
      user-select: none;
      transition: background .15s, transform .1s;
      &:hover {
        background: var(--te-hover, rgba(0,0,0,.04));
        transform: scale(1.03);
      }
      &:active { transform: scale(.97); }
    }
    .el-simge { font-size: 14px; flex-shrink: 0; }
    .el-isim { font-size: 10px; color: var(--te-text-secondary, rgba(0,0,0,.6)); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

    .dar {
      .kategori-baslik { justify-content: center; padding: 6px 4px; }
      .kat-ok { display: none; }
      .eleman-tile { justify-content: center; padding: 5px 2px; }
      .dar-grid { grid-template-columns: 1fr 1fr; gap: 2px; padding: 0 1px 4px; }
    }

    :host-context(body.tema-karanlik) {
      --te-border: rgba(255,255,255,.06);
      --te-hover: rgba(255,255,255,.08);
      --te-scrollbar: rgba(255,255,255,.15);
      --te-text-secondary: rgba(255,255,255,.6);
      --te-text-muted: rgba(255,255,255,.3);
    }
  `,
})
export class TePaletComponent {
  elementEklendi = output<ElementTur>();
  darMod = input(false);
  kategoriler = KATEGORILER;
}
